import { Button, type ButtonProps } from 'antd';
import { AntIcon } from '../../../components/AntIcon';

export interface ISimpleTriggerActionButtonProps extends ButtonProps {
  text?: string;
  visible?: boolean;
  icon?: string;
}

const SimpleTriggerActionButton = ({
  text,
  visible,
  icon,
  ...rest
}: ISimpleTriggerActionButtonProps) => {
  if (visible === false) return null;

  const iconElement = icon ? <AntIcon name={icon as any} /> : undefined;

  return (
    <Button {...rest} icon={iconElement}>
      {text}
    </Button>
  );
};

export default SimpleTriggerActionButton;
